export const HOME = 'HOME';
export const ABOUT = 'ABOUT';
export const ACCOUNT = 'ACCOUNT';
export const ITEM = 'ITEM';
